(function () {
    'use strict';

    var blocksRegistry = window.wc.wcBlocksRegistry;
    var settings = window.wc.wcSettings;
    var sanitize = window.wc.sanitize;
    var element = window.wp.element;
    var htmlEntities = window.wp.htmlEntities;
    var i18n = window.wp.i18n;
    var data = settings.getPaymentMethodData('gusmer_purchase_order', {});
    var title = htmlEntities.decodeEntities(
        data.title || i18n.__('Purchase Order', 'vector')
    );

    var Content = function () {
        return element.createElement(
            'section',
            {
                className: 'purchase-order-notice',
                'aria-labelledby': 'purchase-order-notice-heading'
            },
            element.createElement('h3', { id: 'purchase-order-notice-heading' }, i18n.__('Notice', 'vector')),
            element.createElement(element.RawHTML, {
                children: sanitize.sanitizeHTML(data.notice || '', {
                    tags: sanitize.DEFAULT_ALLOWED_TAGS.concat([
                        'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li',
                        'blockquote', 'hr', 'span', 'div', 's', 'del', 'sub', 'sup'
                    ]),
                    attr: sanitize.DEFAULT_ALLOWED_ATTR.concat(['class', 'style'])
                })
            })
        );
    };

    var Label = function (props) {
        return element.createElement(props.components.PaymentMethodLabel, {
            text: title
        });
    };

    blocksRegistry.registerPaymentMethod({
        name: 'gusmer_purchase_order',
        label: element.createElement(Label),
        content: element.createElement(Content),
        edit: element.createElement(Content),
        placeOrderButtonLabel: i18n.__('Submit Purchase Order', 'vector'),
        canMakePayment: function () {
            return true;
        },
        ariaLabel: title,
        supports: {
            features: data.supports || []
        }
    });
}());



// WEBPACK FOOTER //
// ./resources/assets/scripts/woocommerce-purchase-order-blocks.js